import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { OpsgenieIcon } from '@atlaskit/temp-nav-app-icons/opsgenie';

import { Products } from '../../constants';
import type { GlobalShortcutsItem } from '../../types';

import { messages } from './messages';

export default function opsgenie(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <OpsgenieIcon size="20" />,
		apsKey: Products.OPSGENIE,
		label: <FormattedMessage {...messages.label} />,
		fallbackUrl,
	};
}
